import { useContent } from '@wix/funnel-builder-lizard'
import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { WixMobileCategory as WixMobileCategoryUnwrapped } from './WixMobileCategory'
import { TWixMobileCategory } from './WixMobileCategory.content'
import { WixMobileCategoryNoSuggestions } from './WixMobileCategoryNoSuggestions/WixMobileCategoryNoSuggestions'

export const WixMobileCategory: FC = () => {
  const { content } = useContent<TWixMobileCategory>()
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])
  if (content.inputType === 'text') {
    return <WixMobileCategoryNoSuggestions />
  }
  return <WixMobileCategoryUnwrapped businessTermService={businessTermService} />
}
